<div class="controls-container">
    <div class="controls-header">Tree1</div>
    <pm-tree [ItemsSource]="ItemsSource"
             [DisplayMemberPath]="'Name'"
             [ChildPath]="'Children'"
             [(SelectedItem)]="SelectedItem">
        <ng-template #ItemTemplate let-item>
            {{item.Name}}
        </ng-template>
    </pm-tree>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/tree/tree.html